import React from "react";
import "./FormComponents.css";
const InputBox = ({ label, field, type="text", placeholder, value, onChange, isrequired=false, readOnly=false, error, className="" }) => (
  <div className={`input-box-wrapper ${className}`}>
    {label && <label className="form-label">{label}{isrequired && <span className="required-star">*</span>}</label>}
    {type === "textarea"
      ? <textarea className={`form-input form-textarea${error?" input-error":""}`} placeholder={placeholder} value={value||""} onChange={e => onChange&&onChange(field,e.target.value)} readOnly={readOnly} rows={4}/>
      : <input
          className={`form-input${error?" input-error":""}`}
          type={type}
          placeholder={placeholder}
          value={value||""}
          onChange={e => onChange&&onChange(field,e.target.value)}
          readOnly={readOnly}
          onWheel={type === "number" ? (e) => { e.currentTarget.blur(); } : undefined}
        />
    }
    {error && <span className="error-msg">{error}</span>}
  </div>
);
export default InputBox;